import classes from "./ShareModal.module.scss";
import { useRef, useState } from "react";
import CustomDatePicker from "../CustomDatePicker";
import createShareItemMutation from "graphql/mutations/CreateShareItemMutation";
import CopyInput from "../Input/CopyInput";
import { STUDIO_URL } from "constants/env";
import ImgModal from "../ImgModal/ImgModal";
import { useTranslation } from "react-i18next";

function Sharing({ handleClose, itemId, itemName, onUrlCreated, ...others }) {
  const { t } = useTranslation();
  const [state, setState] = useState({
    itemId,
    ...others,
    start: new Date(),
    end: new Date(),
    securityPass: "",
    emailsToShare: "",
  });

  const [url, setUrl] = useState("");
  const inputRef = useRef(null);
  function copyUrl(e) {
    inputRef.current.select();
    document.execCommand("copy");
    e.target.focus();
  }

  const handleState = e => {
    const { name, value } = e.target;
    setState(prev => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const [addExpiry, setAddExpiry] = useState(false);
  const handleAddExpiry = () => {
    setAddExpiry(prev => !prev);
  };
  const generateLink = type => {
    const { start, end, emailsToShare, ...values } = { ...state };

    const emails = emailsToShare.split(",").map(email => email.trim());
    values.emails = !!emails ? emails : undefined;
    values.securityPass = values.securityPass.trim();
    values.activeStartDate = start;
    values.activeEndDate = end;

    values.itemName = itemName;
    createShareItemMutation(values, ({ slug }) => {
      if (type === "generate") {
        if (itemName === "magazine") {
          onUrlCreated(`${STUDIO_URL}/magazine/share/${slug}`);
        } else {
          onUrlCreated(`${STUDIO_URL}/share/${slug}`);
        }
      } else {
        setUrl(`${STUDIO_URL}/share/${slug}`);
      }
    });
  };

  return (
    <ImgModal extraClass="sharing-first-modal" state={true}>
      <div className={classes.inner}>
        <div className={`${classes.inputGroup} inputGroup`}>
        <p>{t("share-with")}</p>
          <input
            type="text"
            name="emailsToShare"
            value={state.emailsToShare}
            onChange={handleState}
            placeholder={t("add-emails")}
          />
        </div>
        <p>{t("security-password")}</p>
        <CopyInput
          name="securityPass"
          type="text"
          value={state.securityPass}
          onChange={handleState}
          placeholder={t("security-pass")}
          className="inputGroup"
          icon={true}
        />

        <div className={`${classes.expirylabel} checkbox-label`}>
          <input
            type="checkbox"
            checked={addExpiry}
            onChange={handleAddExpiry}
            name="accessedBy"
            placeholder={t("add-emails")}
            className={`${classes.checkboxinput}`}
          />{" "}
          <p>{t("expiry-duration")}</p>
        </div>
        {addExpiry && (
          <div style={{width:"100%"}}>
            <CustomDatePicker {...{ ...state, setState }} />
          </div>
        )}
        <div className={classes["bottombtn"]}>
          <button onClick={handleClose} submitbutton={"true"}>
            {t("cancel")}
          </button>
          <button
            onClick={() => generateLink("generate")}
            submitbutton={"true"}
          >
            {t("generate-link")}
          </button>
        </div>
      </div>
    </ImgModal>
  );
}
export default Sharing;
